// extracted by mini-css-extract-plugin
module.exports = {"frame":"R+zF53z7GeJbWBt76+-FWw=="};